import { IPreloadedState } from 'shared/types/redux';
import { ISearchMeta } from 'shared/types/searchMeta';

export const selectSearchMetaData = (state: IPreloadedState) => state.searchMeta.data as ISearchMeta;
